import { render, staticRenderFns } from "./TransloadDetails.vue?vue&type=template&id=1437bbae&scoped=true"
import script from "./TransloadDetails.vue?vue&type=script&lang=js"
export * from "./TransloadDetails.vue?vue&type=script&lang=js"
import style0 from "./TransloadDetails.vue?vue&type=style&index=0&id=1437bbae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1437bbae",
  null
  
)

export default component.exports